/**
 * @desc 时效设置-更新默认时效
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.TimelinessSettingRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/timelinessSetting/defaultUpdate`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
